<template>
<section ref="root" class="big-link bg-primary-400 px-4 py-10%">
    <Link :href="links_to" class="text-center block relative z-10">
        <SmoothLoader>
            <span v-if="kicker" class="kicker block text-white font-headline font-bold uppercase" v-html="kicker"></span>

            <span class="title block text-primary-800 text-4xl vt:text-7xl ht:text-8xl font-headline font-bold leading-none my-0" v-html="title"></span>

            <div class="flex justify-center mt-8">
                <span class="circle-icon relative inline-block w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-lg" aria-hidden="true">
                    <i class="fa-solid fa-arrow-circle-right text-2xl text-secondary-500 relative"></i>
                </span>
            </div>
        </SmoothLoader>
    </Link>
</section>
</template>

<script>
const $ = window.jQuery;
import { onMounted, ref, onBeforeUnmount } from 'vue';
export default {
    props: ['data'],
    setup(props) {

        const root = ref(null);
        const fixSlicesBackground = () => {
            let height = root.value.clientHeight;
            $('.slices-outer').css('background-position', `center bottom ${height}px`);
        };

        onMounted(() => {
            fixSlicesBackground();
            $(window).on('resize', fixSlicesBackground);
        });

        onBeforeUnmount(() => {
            $(window).off('resize', fixSlicesBackground);
        });

        return {
            root,
            ...props.data
        }
    }
}
</script>